import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SerialNumbers_ds_handle_serialnumbers_lots_ddService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { licenseplateIds?: number[], locationId?: number, warehouseIds?: number[], lotId?: number, materialIds?: number[], projectId?: number, ownerId?: number, archived?: boolean, fullTextSearch?: string, textSearch?: string, orderId?: number, orderLineNumber?: number, selectorSearch?: string, $top?: number, $skip?: number }): Promise<{ result?: { LotId?: number, Lookup?: string }[], totalCount?: number }> {
    let url = `${environment.backendUrl}api/SerialNumbers/datasources/ds_handle_serialnumbers_lots_dd/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { licenseplateIds?: number[], locationId?: number, warehouseIds?: number[], lotId?: number, materialIds?: number[], projectId?: number, ownerId?: number, archived?: boolean, fullTextSearch?: string, textSearch?: string, orderId?: number, orderLineNumber?: number, selectorSearch?: string, $keys: number[] }): Promise<{ result?: { LotId?: number, Lookup?: string }[] }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SerialNumbers/datasources/ds_handle_serialnumbers_lots_dd/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      licenseplateIds?: number[], locationId?: number, warehouseIds?: number[], lotId?: number, materialIds?: number[], projectId?: number, ownerId?: number, archived?: boolean, fullTextSearch?: string, textSearch?: string, orderId?: number, orderLineNumber?: number, selectorSearch?: string    }) {
      return false;
    }
}
